import Vue from 'vue';
import PendoInput from '../../components/input/pendo-input.vue.js';
import PendoButton from '../../components/button/pendo-button.vue.js';
import PendoCollapse from '../../components/collapse/pendo-collapse.vue.js';
import PendoTag from '../../components/tag/pendo-tag.vue.js';

var script = {
  name: 'PendoRepeatingRegexpInput',
  components: {
    PendoInput,
    PendoCollapse,
    PendoButton,
    PendoTag
  },
  props: {
    value: {
      type: Array,
      default: () => [{
        subDomainRegExp: '',
        pathRegExp: '',
        rootDomain: ''
      }]
    },
    domainValidator: {
      type: Function,
      required: true
    },
    regexValidator: {
      type: Function,
      required: true
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    panels: {
      type: Array,
      default: () => [{
        name: 'regexp1',
        title: 'Selective URL 1'
      }]
    },
    activePanel: {
      type: Array,
      default: () => ['regexp1']
    }
  },
  data() {
    return {
      regexps: [{
        subDomainRegExp: '',
        pathRegExp: '',
        rootDomain: ''
      }],
      localPanels: [{
        name: 'regexp1',
        title: 'Selective URL 1'
      }],
      localActivePanel: ['regexp1']
    };
  },
  computed: {
    disableDelete() {
      return this.regexps.length <= 1 && !Object.keys(this.regexps[0]).filter(key => this.regexps[0][key] !== '').length;
    }
  },
  watch: {
    regexps(value) {
      this.$emit('input', value);
    },
    value(value) {
      this.regexps = value;
    },
    panels(value) {
      this.localPanels = value;
    },
    activePanel(value) {
      this.localActivePanel = value;
    }
  },
  created() {
    this.regexps = this.value;
    this.localPanels = this.panels;
    this.localActivePanel = this.activePanel;
  },
  methods: {
    removeField(i) {
      if (this.regexps.length === 1) {
        this.regexps = [{
          subDomainRegExp: '',
          pathRegExp: '',
          rootDomain: ''
        }];
      } else {
        this.localPanels = this.localPanels.slice(0, i).concat(this.localPanels.slice(i + 1));
        this.localPanels = this.updatePanelNames(this.localPanels);
        this.regexps = this.regexps.slice(0, i).concat(this.regexps.slice(i + 1));
        this.$emit('updatePanel', this.localPanels);
        this.localActivePanel = [this.localPanels[i < this.localPanels.length ? i : i - 1].name];
        this.$emit('updateActivePanel', this.localActivePanel);
      }
    },
    onInputChange(event, objKey) {
      const objToUpdate = this.regexps[event.index];
      objToUpdate[objKey] = event.value;
      Vue.set(this.regexps, event.index, objToUpdate);
    },
    addField() {
      this.regexps.push({
        subDomainRegExp: '',
        pathRegExp: '',
        rootDomain: ''
      });
      this.localPanels.push({
        name: `regexp${this.localPanels.length + 1}`,
        title: `Selective URL ${this.localPanels.length + 1}`
      });
      this.$nextTick(() => {
        this.$refs[`regexp${this.regexps.length - 1}`][0].focus();
      });
      this.localActivePanel = `regexp${this.localPanels.length}`;
    },
    updatePanelNames(panelsToUpdate) {
      const tempPaneArr = [];
      for (let index = 0; index < panelsToUpdate.length; index++) {
        tempPaneArr.push({
          name: `regexp${index + 1}`,
          title: `Selective URL ${index + 1}`
        });
      }
      return tempPaneArr;
    }
  }
};

export { script as default };
//# sourceMappingURL=repeating-regexp-input.vue2.js.map
